// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1uq2s","calendarButtons":"ClockData_calendarButtons__2qji_"};